import React, { useLayoutEffect, useState } from 'react'
import { Global } from '@emotion/core'
import { ThemeProvider, Flex, Box, css } from 'theme-ui'
import theme from '@elegantstack/flow-ui-theme/src/theme'
import pageContextProvider from '@helpers/pageContextProvider'
import { Header } from '../Header/Header'
import { Footer } from '../Footer/Footer'

let isFirstTimeRender = true;

export const Layout = ({ children, pageContext, location }) => {
  
  let initialColorModeName = 'default';

  if (typeof window !== 'undefined') {
    if (!isFirstTimeRender) {
      initialColorModeName = localStorage.getItem('theme-ui-color-mode');
    }
  }
  const [setThemeObj, setSetThemeObj] = useState({ ...theme, initialColorModeName });

  useLayoutEffect(() => {
    if (typeof window !== 'undefined') {
      initialColorModeName = localStorage.getItem('theme-ui-color-mode');
      isFirstTimeRender = false;
      setSetThemeObj({ ...theme, initialColorModeName })
    }
  }, []);

  const GTM_SCRIPT_ID = 'GTM-PXM8RCCN'

  const GTMScript = `(function(w,d,s,l,i) {
    w[l]=w[l]||[];
    w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
    var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
    j.async=true;
    j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
    f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','${GTM_SCRIPT_ID}');`

  
  return (
    <>
   {setThemeObj&& <ThemeProvider theme={setThemeObj}>
      <pageContextProvider.Provider value={{ pageContext, location }}>
        <Flex variant='layout.layout'>
          <Global styles={css(theme => theme.global)} />
          <Header />
          <Box variant='layout.body'>{children}</Box>
          <Footer />
        </Flex>
      </pageContextProvider.Provider>
    </ThemeProvider>}
    <script dangerouslySetInnerHTML={{ __html: GTMScript }} />
      <noscript>
        <iframe
          src={`https://www.googletagmanager.com/ns.html?id=${GTM_SCRIPT_ID}`}
          height="0"
          width="0"
          style={{ display: 'none', visibility: 'hidden' }}
        />
      </noscript>
    </>
  )
}
